import * as _ from 'lodash';
import { Label, ListGroup, Panel } from 'react-bootstrap';
import { ICenterPerformance, ICenterPerformanceCompliance } from '@nkr/models/center-performance';
import { DonorType } from '@nkr/enums/donor-type';
import ComplianceIssueList from './compliance-issue-list';
import { PanelWrapper } from './styles';
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';
import { useState } from 'react';

interface IProps {
    // data: ICenterPerformance,
    data: ICenterPerformanceCompliance,
    centerId: number,
    recipientsDonorsExpanded: boolean,
    postTxpRecipientsDonorsExpanded: boolean,
    micrositeRecipientsExpanded: boolean,
    loading: boolean,
    onRecipientsDonorsExpanded: () => void,
    onPostTxpRecipientsDonorsExpanded: () => void,
    onMicrositeRecipientsExpanded: () => void
}

const DataComplianceIssues = (props: IProps) => {
    const [expandDashCompliance, setExpandDashCompliance] = useState<boolean>(false);

    if (props.data == null) {
        return (
            <Panel id='data-compliance'>
                <Panel.Heading>
                    <Panel.Title>Data-Compliance Issues Found (loading...)</Panel.Title>
                </Panel.Heading>
                <Panel.Body><Label style={{ fontSize: '100%' }}>Loading data, one moment please...</Label></Panel.Body>
            </Panel>
        );
    }

    const {
        complianceLog, centerCompliance,
        donorCompliance, postTxpDonorCompliance, rdnDonorCompliance, postTxpRdnDonorCompliance,
        recipientCompliance, dashRemoteStatusCompliance, postTxpRecipientCompliance, recipientCount, micrositeCompliance
    } = props.data;

    const { overallChecked, overallFailed, overallPercent } = complianceLog;

    const issueCount = overallFailed;

    const dataComplianceCount = donorCompliance.length + rdnDonorCompliance.length + recipientCompliance.length;
    const postTxpDataComplianceCount = postTxpDonorCompliance.length + postTxpRdnDonorCompliance.length + postTxpRecipientCompliance.length;

    const overallPercentDisplay = overallPercent.toFixed(1);

    const micrositeComplianceCount = micrositeCompliance.length;

    const sortedMicrositeDataCompliance = _.sortBy(micrositeCompliance, x => x.lastName);

    const centerComplianceCount = centerCompliance.complianceIssues.length;
    const donorComplianceCount = _.sumBy(donorCompliance, x => x.complianceIssues.length);
    const rdnDonorComplianceCount = _.sumBy(rdnDonorCompliance, x => x.complianceIssues.length);
    const recipientComplianceCount = _.sumBy(recipientCompliance, x => x.complianceIssues.length);
    const postTxpDonorComplianceCount = _.sumBy(postTxpDonorCompliance, x => x.complianceIssues.length);
    const postTxpRdnDonorComplianceCount = _.sumBy(postTxpRdnDonorCompliance, x => x.complianceIssues.length);
    const postTxpRecipientComplianceCount = _.sumBy(postTxpRecipientCompliance, x => x.complianceIssues.length);
    const dashRemoteStatusComplianceCount = dashRemoteStatusCompliance.length;

    const billableCount =
        centerComplianceCount
        + donorComplianceCount
        + rdnDonorComplianceCount
        + recipientComplianceCount
        + postTxpDonorComplianceCount
        + postTxpRdnDonorComplianceCount
        + postTxpRecipientComplianceCount
        + dashRemoteStatusComplianceCount;

    const notBillableCount = micrositeComplianceCount;

    return (
        <Panel id='data-compliance'>
            <Panel.Heading>
                <Panel.Title>Data Compliance Issues Found (billable: {billableCount}, not billable: {notBillableCount})</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
                {overallFailed == 0 && (
                    <p style={{ fontWeight: 'bold', marginBottom: 10 }}>
                        A total of {overallChecked} data compliance items were examined and there were no exceptions found. This gives a Data Compliance score of {overallPercentDisplay}%
                    </p>
                )}

                {overallFailed == 1 && (
                    <p style={{ fontWeight: 'bold', marginBottom: 10 }}>
                        A total of {overallChecked} data compliance items were examined and the {issueCount} item listed below was an exception. This gives a Data Compliance score of {overallPercentDisplay}%
                    </p>
                )}

                {overallFailed > 1 && (
                    <p style={{ fontWeight: 'bold', marginBottom: 10 }}>
                        A total of {overallChecked} data compliance items were examined and the {issueCount} items listed below were exceptions. This gives a Data Compliance score of {overallPercentDisplay}%
                    </p>
                )}

                {centerCompliance.complianceIssues.length > 0 && (
                    <div style={{ marginBottom: 10 }}>
                        <p style={{ marginBottom: 5 }}><strong>Your center is missing important member center profile information:</strong></p>
                        <ul>
                            {centerCompliance.complianceIssues.map((issue, index) =>
                                <li key={'cc-' + index}>{ReactHtmlParser(issue)}</li>
                            )}
                        </ul>
                    </div>
                )}

                {recipientCount == 0 && (
                    <p style={{ marginBottom: 10 }}>
                        <strong>
                            Your center currently has no pairs entered and exportable. Please let us know if you need any training to enter pairs or
                            to initiate an outreach program to your patients with incompatible donors.
                        </strong>
                    </p>
                )}

                {dashRemoteStatusCompliance.length > 0 && (
                    <PanelWrapper expanded={expandDashCompliance}>
                        <Panel.Heading style={{ cursor: 'pointer' }} onClick={() => setExpandDashCompliance(!expandDashCompliance)}>
                            <Panel.Title>The following DASH Referrals require updates</Panel.Title>
                        </Panel.Heading>
                        <Panel.Collapse>
                            <Panel.Body>
                                <ol>
                                    {dashRemoteStatusCompliance.map((item, index) => {
                                        let editLink = '/center/' + props.centerId + '/donors/donor-intake/details/' + item.id;

                                        return (<li key={`dashcmpl-${index}`}>Please update the <strong>Network Status</strong> for the DASH donor, <Link to={editLink}>{item.fullName}</Link>, to keep {item.patientCenter} updated</li>);
                                    })}
                                </ol>
                            </Panel.Body>
                        </Panel.Collapse>
                    </PanelWrapper>
                )}

                {dataComplianceCount > 0 && (
                    <>
                        <PanelWrapper expanded={props.recipientsDonorsExpanded}>
                            <Panel.Heading style={{ cursor: 'pointer' }} onClick={props.onRecipientsDonorsExpanded}>
                                <Panel.Title>
                                    The following Recipients/Donors are missing important information which will reduce their chances of a match
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Collapse>
                                {props.recipientsDonorsExpanded && (
                                    <Panel.Body>
                                        {recipientCompliance.length > 0 && (
                                            <Panel>
                                                <Panel.Heading style={{ backgroundColor: 'ghostwhite', padding: '7.5px 15px' }}>Recipients</Panel.Heading>
                                                <ListGroup>
                                                    {recipientCompliance.map((item, index) =>
                                                        <ComplianceIssueList
                                                            key={'rcmpl-' + index}
                                                            editLink={'center/' + props.centerId + '/recipient/' + item.id + '/profile/general'}
                                                            alias={item.alias}
                                                            rowNumber={index + 1}
                                                            issues={item.complianceIssues}
                                                        />
                                                    )}
                                                </ListGroup>
                                            </Panel>
                                        )}

                                        {donorCompliance.length > 0 && (
                                            <Panel>
                                                <Panel.Heading style={{ backgroundColor: 'ghostwhite', padding: '7.5px 15px' }}>Donors</Panel.Heading>
                                                <ListGroup>
                                                    {donorCompliance.map((item, index) => {
                                                        let editLink = '/center/' + props.centerId + '/donor/' + item.id + '/profile';

                                                        return (
                                                            <ComplianceIssueList
                                                                key={'dcmpl-' + index}
                                                                editLink={editLink}
                                                                alias={item.alias}
                                                                rowNumber={index + 1}
                                                                issues={item.complianceIssues}
                                                            />
                                                        );
                                                    })}
                                                </ListGroup>
                                            </Panel>
                                        )}

                                        {rdnDonorCompliance.length > 0 && (
                                            <Panel >
                                                <Panel.Heading style={{ backgroundColor: 'ghostwhite', padding: '7.5px 15px' }}>RDN Donors</Panel.Heading>
                                                <ListGroup>
                                                    {rdnDonorCompliance.map((item, index) => {
                                                        let editLink = '/center/' + props.centerId + '/donor/' + item.id + '/profile';

                                                        return (
                                                            <ComplianceIssueList
                                                                key={'rdnDcmpl-' + index}
                                                                editLink={editLink}
                                                                alias={item.alias}
                                                                rowNumber={index + 1}
                                                                issues={item.complianceIssues}
                                                            />
                                                        );
                                                    })}
                                                </ListGroup>
                                            </Panel>
                                        )}

                                    </Panel.Body>
                                )}
                            </Panel.Collapse>
                        </PanelWrapper>
                    </>
                )}

                {postTxpDataComplianceCount > 0 && (
                    <PanelWrapper expanded={props.postTxpRecipientsDonorsExpanded}>
                        <Panel.Heading>
                            <Panel.Title style={{ cursor: 'pointer' }} onClick={props.onPostTxpRecipientsDonorsExpanded}>
                                The following Recipients/Donors are missing important post transplant information
                            </Panel.Title>
                        </Panel.Heading>
                        <Panel.Collapse>
                            {props.postTxpRecipientsDonorsExpanded && (
                                <Panel.Body>
                                    {postTxpRecipientCompliance.length > 0 && (
                                        <Panel>
                                            <Panel.Heading style={{ backgroundColor: 'ghostwhite', padding: '7.5px 15px' }}>Post Transplant Recipients</Panel.Heading>
                                            <ListGroup>
                                                {postTxpRecipientCompliance.map((item, index) =>
                                                    <ComplianceIssueList
                                                        key={'ptxpRcmpl-' + index}
                                                        editLink={'center/' + props.centerId + '/recipient/' + item.id + '/profile/general'}
                                                        alias={item.alias}
                                                        rowNumber={index + 1}
                                                        issues={item.complianceIssues}
                                                    />
                                                )}
                                            </ListGroup>
                                        </Panel>
                                    )}

                                    {postTxpDonorCompliance.length > 0 && (
                                        <Panel>
                                            <Panel.Heading style={{ backgroundColor: 'ghostwhite', padding: '7.5px 15px' }}>Post Transplant Donors</Panel.Heading>
                                            <ListGroup>
                                                {postTxpDonorCompliance.map((item, index) => {
                                                    let editLink = '/center/' + props.centerId + '/donor/' + item.id + '/profile';

                                                    return (
                                                        <ComplianceIssueList
                                                            key={'ptxpDcmpl-' + index}
                                                            editLink={editLink}
                                                            alias={item.alias}
                                                            rowNumber={index + 1}
                                                            issues={item.complianceIssues}
                                                        />
                                                    )
                                                })}
                                            </ListGroup>
                                        </Panel>
                                    )}

                                    {postTxpRdnDonorCompliance.length > 0 && (
                                        <Panel>
                                            <Panel.Heading style={{ backgroundColor: 'ghostwhite', padding: '7.5px 15px' }}>Post Transplant RDN Donors</Panel.Heading>
                                            <ListGroup>
                                                {postTxpRdnDonorCompliance.map((item, index) => {
                                                    let editLink = '/center/' + props.centerId + '/donor/' + item.id + '/profile';

                                                    return (
                                                        <ComplianceIssueList
                                                            key={'ptxpRdnDcmpl-' + index}
                                                            editLink={editLink}
                                                            alias={item.alias}
                                                            rowNumber={index + 1}
                                                            issues={item.complianceIssues}
                                                        />
                                                    )
                                                })}
                                            </ListGroup>
                                        </Panel>
                                    )}
                                </Panel.Body>
                            )}
                        </Panel.Collapse>
                    </PanelWrapper>
                )}

                {micrositeComplianceCount > 0 && (
                    <PanelWrapper expanded={props.micrositeRecipientsExpanded} style={{ marginBottom: 0 }}>
                        <Panel.Heading>
                            <Panel.Title style={{ cursor: 'pointer' }} onClick={props.onMicrositeRecipientsExpanded}>
                                The following Microsite Recipients are missing required data
                            </Panel.Title>
                        </Panel.Heading>
                        <Panel.Collapse>
                            {props.micrositeRecipientsExpanded && (
                                <Panel.Body>
                                    <ListGroup style={{ marginBottom: 0 }}>
                                        {sortedMicrositeDataCompliance.map((item, index) =>
                                            <ComplianceIssueList
                                                key={'microsite-' + index}
                                                editLink={item.link}
                                                alias={item.firstName + ' ' + item.lastName}
                                                rowNumber={index + 1}
                                                issues={item.complianceIssues}
                                                target='_blank'
                                            />
                                        )}
                                    </ListGroup>
                                </Panel.Body>
                            )}
                        </Panel.Collapse>
                    </PanelWrapper>
                )}
            </Panel.Body>
        </Panel>
    );
}

export default DataComplianceIssues;